import React from 'react';
import DynamicForm from '../Dynamic/components/InputForm/InputForm';
import GraphicDynamic from '../Dynamic/components/Graphic/Graphic';
import ResultsDynamic from '../Dynamic/components/Results/Results';
import * as ProjectDynamic from '../Dynamic/store/project/projectslice';
import GraphicContainerYard from '../ContainerYard/components/Graphic/Graphic';
import GraphicPavements from '../Pavements/components/Graphic/Graphic';
import GraphicAirport from '../Airport/components/Graphic/Graphic';
import GraphicRailway from '../Railway/components/Graphic/Graphic';
import ResultsContainerYard from '../ContainerYard/components/Results/Results';
import ResultsPavements from '../Pavements/components/Results/Results';
import ResultsPaved from '../Pavements/components/Results/Results_Paved';
import ResultsAirport from '../Airport/components/Results/Results_Airport';
import ResultsRailway from '../Railway/components/Results/Results';
import { EProjectType } from '../enum/project';
import { logDebug } from '../utils/utils';

//container_yard e parking_deck hanno la stessa struttura
// e quindi usano lo stesso componente Graphic e Results cambiando solo il gruppo load e l'immagine della gomma al posto di container

/**
 * Pure function that returns action components based on project type
 * @param projectType - The project type to get actions for
 * @returns Action components and setProject function for the specified project type
 */
export const getActionByProjectType = (projectType: EProjectType) => {
    logDebug('ActionMap', 'getActionByProjectType called with projectType:', projectType);
    switch (projectType) {
        case EProjectType.container_yard:
            return {
                inputForm: <DynamicForm />,
                graphic: <GraphicContainerYard />,
                results: <ResultsContainerYard />,
                setProject: ProjectDynamic.setProject,
            };
        case EProjectType.parking_deck:
            return {
                inputForm: <DynamicForm />,
                graphic: <GraphicContainerYard />,
                results: <ResultsContainerYard />,
                setProject: ProjectDynamic.setProject,
            };
        case EProjectType.paved:
            return {
                inputForm: <DynamicForm />,
                graphic: <GraphicPavements />,
                results: <ResultsPaved />,
                setProject: ProjectDynamic.setProject,
            };
        case EProjectType.airport:
            return {
                inputForm: <DynamicForm />,
                graphic: <GraphicAirport />,
                results: <ResultsAirport />,
                setProject: ProjectDynamic.setProject,
            };
        case EProjectType.unpaved:
            return {
                inputForm: <DynamicForm />,
                graphic: <GraphicPavements />,
                results: <ResultsPavements />,
                setProject: ProjectDynamic.setProject,
            };
        case EProjectType.railways:
            return {
                inputForm: <DynamicForm />,
                graphic: <GraphicRailway />,
                results: <ResultsRailway />,
                setProject: ProjectDynamic.setProject,
            };
        default:
            return {
                inputForm: <DynamicForm />,
                graphic: <GraphicDynamic />,
                results: <ResultsDynamic />,
                setProject: ProjectDynamic.setProject,
            };
    }
};
